<template>
    <div>
        <!-- FILTROS -->
        <div class="row mb-3 align-items-end">
            <div class="col-md-2">
                <label class="font-weight-bold">Fecha inicio:</label>
                <date-picker v-model="filters.fechaInicio" value-type="format" format="YYYY-MM-DD" placeholder="YYYY-MM-DD" class="w-100"></date-picker>
            </div>
            <div class="col-md-2">
                <label class="font-weight-bold">Fecha fin:</label>
                <date-picker v-model="filters.fechaFin" value-type="format" format="YYYY-MM-DD" placeholder="YYYY-MM-DD" class="w-100"></date-picker>
            </div>
            <div class="col-md-2">
                <label class="font-weight-bold">Canal:</label>
                <select-canalesN ref="selectCanal" placeholderm="canal" @cambioCanal="onChangeCanal"></select-canalesN>
            </div>
            <div class="col-md-2">
                <label class="font-weight-bold">Cadena:</label>
                <select-cadenasN ref="selectCadena" placeholderm="cadena" @cambioCadena="onChangeCadena"></select-cadenasN>
            </div>
            <div class="col-md-2">
                <label class="font-weight-bold">Formato:</label>
                <select-formatosN ref="selectFormato" placeholderm="formato" @cambioFormato="onChangeFormato"></select-formatosN>
            </div>
            <div class="col-md-2 d-flex align-items-end">
                <button class="btn btn-primary btn-block" @click="getDashboard" :disabled="loading">
                    <span v-if="loading"><i class="fas fa-spinner fa-spin mr-1"></i> Cargando...</span>
                    <span v-else><i class="fas fa-search mr-1"></i> Generar</span>
                </button>
            </div>
        </div>

        <!-- SEMÁFORO CONFIG -->
        <div class="card mb-3 border-0 shadow-sm">
            <div class="card-body py-2">
                <div class="row align-items-center">
                    <div class="col-auto">
                        <i class="fas fa-traffic-light mr-1 text-warning"></i>
                        <strong>Configurar Semáforo:</strong>
                    </div>
                    <div class="col-auto d-flex align-items-center">
                        <span class="badge badge-danger mr-1">Mín</span>
                        <input type="number" v-model.number="semaforo.min" class="form-control form-control-sm" style="width:70px" min="0">
                    </div>
                    <div class="col-auto d-flex align-items-center">
                        <span class="badge badge-warning mr-1">Normal</span>
                        <input type="number" v-model.number="semaforo.normal" class="form-control form-control-sm" style="width:70px" min="0">
                    </div>
                    <div class="col-auto d-flex align-items-center">
                        <span class="badge badge-success mr-1">Máx</span>
                        <input type="number" v-model.number="semaforo.max" class="form-control form-control-sm" style="width:70px" min="0">
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-sm btn-outline-secondary" @click="saveSemaforo">
                            <i class="fas fa-save mr-1"></i> Guardar
                        </button>
                    </div>
                    <div class="col-auto ml-auto" v-if="showResults">
                        <button v-if="!loadingExcel" class="btn btn-success btn-sm" @click="exportExcel">
                            <i class="fas fa-file-excel mr-1"></i> Descargar Excel
                        </button>
                        <span v-else class="text-muted"><i class="fas fa-spinner fa-spin mr-1"></i> Preparando...</span>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-12">
                        <small class="text-muted">
                            <span class="badge badge-secondary mr-1">0 pzas</span>Sin stock &nbsp;|&nbsp;
                            <span class="badge badge-danger mr-1">1 – {{ semaforo.min }} pzas</span>Bajo &nbsp;|&nbsp;
                            <span class="badge badge-warning mr-1">{{ semaforo.min + 1 }} – {{ semaforo.normal }} pzas</span>Normal &nbsp;|&nbsp;
                            <span class="badge badge-success mr-1">{{ semaforo.normal + 1 }} – {{ semaforo.max }} pzas</span>Bueno &nbsp;|&nbsp;
                            <span class="badge badge-info mr-1">&gt; {{ semaforo.max }} pzas</span>Alto
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <!-- KPI CARDS -->
        <div class="row mb-3" v-if="showResults">
            <div class="col-md-3 col-6 mb-2">
                <div class="card text-white shadow-sm" style="background: linear-gradient(135deg,#667eea,#764ba2);">
                    <div class="card-body text-center py-3">
                        <i class="fas fa-store fa-2x mb-2"></i>
                        <h3 class="mb-0 font-weight-bold">{{ kpis.tiendasVisitadas }}</h3>
                        <small>Tiendas Visitadas</small>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-6 mb-2">
                <div class="card text-white shadow-sm" style="background: linear-gradient(135deg,#f093fb,#f5576c);">
                    <div class="card-body text-center py-3">
                        <i class="fas fa-exclamation-circle fa-2x mb-2"></i>
                        <h3 class="mb-0 font-weight-bold">{{ kpis.productosEnCero }}</h3>
                        <small>Registros en 0</small>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-6 mb-2">
                <div class="card text-white shadow-sm" style="background: linear-gradient(135deg,#4facfe,#00f2fe);">
                    <div class="card-body text-center py-3">
                        <i class="fas fa-box fa-2x mb-2"></i>
                        <h3 class="mb-0 font-weight-bold">{{ kpis.totalRegistros }}</h3>
                        <small>Total Registros</small>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-6 mb-2">
                <div class="card text-white shadow-sm" style="background: linear-gradient(135deg,#43e97b,#38f9d7);">
                    <div class="card-body text-center py-3">
                        <i class="fas fa-chart-line fa-2x mb-2"></i>
                        <h3 class="mb-0 font-weight-bold">{{ kpis.productosAltos }}</h3>
                        <small>Registros &gt; Máx</small>
                    </div>
                </div>
            </div>
        </div>

        <!-- TOP PRODUCTOS CHART -->
        <div class="row mb-3" v-if="showResults && topProductos.length">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-header bg-dark text-white py-2">
                        <i class="fas fa-trophy mr-1"></i> Top Productos con Mayor Presencia en Tiendas
                    </div>
                    <div class="card-body">
                        <highcharts :options="chartOptions" style="height:350px"></highcharts>
                    </div>
                </div>
            </div>
        </div>

        <!-- TABLA DETALLE -->
        <div class="row" v-if="showResults">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-header bg-dark text-white py-2">
                        <i class="fas fa-list mr-1"></i> Detalle de Inventario por Categorías
                        <span class="badge badge-light ml-2">{{ tableData.length }} registros</span>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table table-sm table-hover mb-0">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Tienda</th>
                                        <th>Cadena</th>
                                        <th>Formato</th>
                                        <th>Canal</th>
                                        <th>Gestor</th>
                                        <th>Código</th>
                                        <th>Producto</th>
                                        <th class="text-center">Cantidad</th>
                                        <th class="text-center">Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, i) in tableData" :key="i" :class="rowClass(row.Cantidad)">
                                        <td>{{ row.Fecha }}</td>
                                        <td>{{ row.Tienda }}</td>
                                        <td>{{ row.Cadena }}</td>
                                        <td>{{ row.Formato }}</td>
                                        <td>{{ row.Canal }}</td>
                                        <td>{{ row.Gestor }}</td>
                                        <td><code>{{ row.CdgProducto }}</code></td>
                                        <td>{{ row.NomProducto }}</td>
                                        <td class="text-center font-weight-bold">{{ row.Cantidad }}</td>
                                        <td class="text-center">
                                            <span :class="badgeClass(row.Cantidad)">{{ badgeLabel(row.Cantidad) }}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="!tableData.length">
                                        <td colspan="10" class="text-center text-muted py-4">Sin registros en el rango seleccionado.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- LOADING -->
        <div class="text-center py-5" v-if="loading">
            <img src="/theme/img/loads/spiralload.gif" height="50" alt="cargando">
            <p class="mt-2"><b>Consultando información, por favor espere...</b></p>
        </div>
    </div>
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
    name: 'inventarioCategorias',
    components: { highcharts: Chart },
    data() {
        return {
            loading: false,
            loadingExcel: false,
            showResults: false,
            filters: {
                fechaInicio: null,
                fechaFin: null,
                canales: [],
                cadenas: [],
                formatos: [],
            },
            semaforo: {
                min: 5,
                normal: 50,
                max: 100,
            },
            kpis: {
                tiendasVisitadas: 0,
                productosEnCero: 0,
                totalRegistros: 0,
                productosAltos: 0,
            },
            topProductos: [],
            tableData: [],
            chartOptions: {},
        };
    },
    mounted() {
        this.loadSemaforo();
    },
    methods: {
        // ─── Semáforo ───────────────────────────────────────────────
        loadSemaforo() {
            const saved = localStorage.getItem('inventario_semaforo_categorias');
            if (saved) {
                try {
                    const parsed = JSON.parse(saved);
                    this.semaforo = { ...this.semaforo, ...parsed };
                } catch (e) { /* ignore */ }
            }
        },
        saveSemaforo() {
            localStorage.setItem('inventario_semaforo_categorias', JSON.stringify(this.semaforo));
            this.$toastMessage('success', 'Semáforo guardado correctamente.', 2500, 'center');
            // Re-colorear tabla si ya hay datos
            if (this.showResults) this.$forceUpdate();
        },

        // ─── Filtros ─────────────────────────────────────────────────
        onChangeCanal() {
            this.filters.canales = this.$refs.selectCanal.selectedCanales
                ? this.$refs.selectCanal.selectedCanales.map(c => c.value)
                : [];
        },
        onChangeCadena() {
            this.filters.cadenas = this.$refs.selectCadena.selectedCadenas
                ? this.$refs.selectCadena.selectedCadenas.map(c => c.value)
                : [];
        },
        onChangeFormato() {
            this.filters.formatos = this.$refs.selectFormato.selectedFormatos
                ? this.$refs.selectFormato.selectedFormatos.map(c => c.value)
                : [];
        },

        // ─── Dashboard ───────────────────────────────────────────────
        getDashboard() {
            if (!this.filters.fechaInicio) {
                this.$toastMessage('error', 'La fecha de inicio es obligatoria.', 4000, 'center');
                return;
            }
            if (!this.filters.fechaFin) {
                this.$toastMessage('error', 'La fecha de fin es obligatoria.', 4000, 'center');
                return;
            }
            this.loading = true;
            this.showResults = false;
            axios.post('/api/Inventarios/reporteCategorias', { data: this.filters })
                .then(r => {
                    this.loading = false;
                    const d = r.data;
                    // KPIs
                    this.kpis.tiendasVisitadas = d.tiendas_visitadas;
                    this.kpis.productosEnCero  = d.productos_en_cero;
                    this.kpis.totalRegistros    = d.total_registros;
                    this.kpis.productosAltos    = d.detalle.filter(x => x.Cantidad > this.semaforo.max).length;
                    // Tabla
                    this.tableData   = d.detalle;
                    // Top productos
                    this.topProductos = d.top_productos;
                    this.buildChart();
                    this.showResults = true;
                })
                .catch(err => {
                    this.loading = false;
                    this.$toastMessage('error', 'Error: ' + err + ' — Contacta a soporte.', 9000, 'center');
                });
        },

        // ─── Chart ───────────────────────────────────────────────────
        buildChart() {
            const top = this.topProductos.slice(0, 10);
            this.chartOptions = {
                chart: { type: 'bar', backgroundColor: 'transparent' },
                title: { text: null },
                xAxis: {
                    categories: top.map(p => p.NomProducto),
                    title: { text: null },
                    labels: { style: { fontSize: '11px' } },
                },
                yAxis: {
                    min: 0,
                    title: { text: 'Número de Tiendas', align: 'high' },
                    allowDecimals: false,
                },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.x + '</b><br/>Presente en <b>' + this.y + '</b> tienda(s)';
                    },
                },
                plotOptions: {
                    bar: {
                        dataLabels: { enabled: true },
                        colorByPoint: false,
                        color: '#667eea',
                    },
                },
                legend: { enabled: false },
                credits: { enabled: false },
                series: [{
                    name: 'Tiendas',
                    data: top.map(p => p.TotalTiendas),
                }],
            };
        },

        // ─── Semáforo helpers ─────────────────────────────────────────
        rowClass(cantidad) {
            cantidad = parseInt(cantidad);
            if (cantidad === 0)                                    return 'table-secondary';
            if (cantidad <= this.semaforo.min)                     return 'table-danger';
            if (cantidad <= this.semaforo.normal)                  return 'table-warning';
            if (cantidad <= this.semaforo.max)                     return 'table-success';
            return 'table-info';
        },
        badgeClass(cantidad) {
            cantidad = parseInt(cantidad);
            if (cantidad === 0)                                    return 'badge badge-secondary';
            if (cantidad <= this.semaforo.min)                     return 'badge badge-danger';
            if (cantidad <= this.semaforo.normal)                  return 'badge badge-warning';
            if (cantidad <= this.semaforo.max)                     return 'badge badge-success';
            return 'badge badge-info';
        },
        badgeLabel(cantidad) {
            cantidad = parseInt(cantidad);
            if (cantidad === 0)                                    return 'Sin stock';
            if (cantidad <= this.semaforo.min)                     return 'Bajo';
            if (cantidad <= this.semaforo.normal)                  return 'Normal';
            if (cantidad <= this.semaforo.max)                     return 'Bueno';
            return 'Alto';
        },

        // ─── Excel ───────────────────────────────────────────────────
        exportExcel() {
            this.loadingExcel = true;
            axios({
                method: 'post',
                url: '/api/Inventarios/exportCategorias',
                responseType: 'arraybuffer',
                data: { data: this.filters },
            }).then(r => {
                const blob = new Blob([r.data], { type: 'application/xlsx' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'InventarioCategoriasMoet.xlsx';
                link.click();
                this.loadingExcel = false;
            }).catch(err => {
                this.loadingExcel = false;
                this.$toastMessage('error', 'Error al exportar: ' + err, 9000, 'center');
            });
        },
    },
};
</script>

<style scoped>
.card { border-radius: 10px; }
.table td, .table th { vertical-align: middle; font-size: 0.85rem; }
.badge { font-size: 0.78rem; padding: 4px 8px; }
</style>
